import React, { useState } from "react";
import { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next"

import { ReactComponent as IconArrowDown } from '../../../../assets/icons/ic-arrow-down.svg';
import { ReactComponent as IconArrowUp } from '../../../../assets/icons/ic-arrow-up.svg';
import { ReactComponent as IconCheckBlue } from '../../../../assets/icons/ic-check-blue.svg';

const colorOptions = [
    { value: "white", label: "White", color: "#FFFFFF" },
    { value: "red", label: "Red", color: "#FF2B5E" },
    { value: "orange", label: "Orange", color: "#FF8F32" },
    { value: "yellow", label: "Yellow", color: "#FDE401" },
    { value: "beige", label: "Beige", color: "#FFD3BD" },
    { value: "green", label: "Green", color: "#3DFF3D" },
    { value: "blue", label: "Blue", color: "#0000FF" },
    { value: "skyblue", label: "Sky blue", color: "#09F4F0" },
    { value: "purple", label: "Purple", color: "#9B92FF" },
    { value: "magenta", label: "Magenta", color: "#FF65ED" },
];

const SetParameterColor = ({parameterColors,selectParameterColors,handleSelectColors}) => {
    const { t } = useTranslation()
    const [openDropdown, setOpenDropdown] = useState({ group: null, key: null });
    const dropdownRefs = useRef({});

    useEffect(() => {
        function handleClickOutside(event) {
            if (openDropdown.key && dropdownRefs.current[openDropdown.key]) {
                const ref = dropdownRefs.current[openDropdown.key];
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpenDropdown({ group: null, key: null });
                }
            }
        }
        if (openDropdown.key) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdown]);

    useEffect(() => {
        console.log('parameterColors : ', parameterColors);
        console.log('selectParameterColors : ', selectParameterColors);
    }, []);
    
    //select box drop down rendering function
    function renderDropdown(paramKey, selected, onChange,type,idx) {
        const dropdownKey = type + paramKey;
        if (!dropdownRefs.current[dropdownKey]) {
            dropdownRefs.current[dropdownKey] = React.createRef();
        }
        //const thisDropdownRef = dropdownRefs.current[paramKey];
        const thisDropdownRef = dropdownRefs.current[dropdownKey];
        const typeName = type === 'wave' ? 'waveParameterColors' : 'numericParameterColors' ;
        const openUp = idx % 5 === 3 || idx % 5 === 4;

        let displaySelected = selected;
        if (!displaySelected) {            
            if (selectParameterColors[typeName] && selectParameterColors[typeName][paramKey]) {
                displaySelected = selectParameterColors[typeName][paramKey];
            }
        }

        const matchedColorOption = colorOptions.find(opt => opt.color === displaySelected?.color);
        // console.log('displaySelected : ', matchedColorOption);

        return (
            <div className="relative" ref={thisDropdownRef}>
                <div
                    className="flex items-center cursor-pointer bg-gradient-to-b from-[#5E5E5E] to-[#383838] px-2"
                    style={{
                        border: '1px solid #5E5E5E',
                        borderRadius: 6,
                        minHeight: 32,
                        height: 32,
                        color: '#DEDEDE',
                        fontWeight: 300,
                        userSelect: 'none',
                        position: 'relative',
                    }}
                    onClick={() => {
                        setOpenDropdown(prev =>
                            prev.key === type + paramKey
                                ? { group: null, key: null } // 이미 열려있으면 닫기
                                : { group: null, key: type + paramKey } // 아니면 열기
                        );
                    }}
                >
                    <span
                        style={{
                            display: 'inline-block',
                            width: 28,
                            height: 20,
                            backgroundColor: matchedColorOption?.color,
                            marginRight: 8,
                            borderRadius: 3,
                        }}
                    />
                    <span>{t(`setting.displayColors.${matchedColorOption?.value}`) || 'Select color'}</span>
                    <span className="ml-auto flex items-center">
                        {openDropdown.key === type+paramKey ? <IconArrowUp /> : <IconArrowDown />}
                    </span>
                </div>
                {openDropdown.key === type+paramKey && (
                    <div
                        className="absolute left-0 mt-1 rounded-[6px] bg-[#1F1F1F] shadow-lg parameter-dropdown-menu"
                        style={{
                            width: 160,
                            maxHeight: 152,
                            overflowY: 'auto',
                            zIndex: 9999,
                            border: '1px solid #5E5E5E',
                            padding: '8px 0',
                            boxShadow: '0px 12px 12px 0px #00000099',
                            ...(openUp
                                ? { bottom: '100%', marginBottom: 8, top: 'auto', marginTop: 0 }
                                : { top: '100%', marginTop: 4, bottom: 'auto', marginBottom: 0 }
                            ),
                        }}
                    >
                        {colorOptions.map((opt, idx) => (
                            <div
                                key={opt.value}
                                className="flex items-center px-2 hover:bg-[#2F2F2F]"
                                style={{
                                    height: 32,
                                    color: selected?.color === opt.color ? '#3182F7' : '#DEDEDE',
                                    fontWeight: 300,
                                    cursor: 'pointer',
                                    gap: 8,
                                    position: 'relative',
                                }}
                                onClick={() => {onChange(type,paramKey,opt.color); setOpenDropdown({ group: null, key: null });}}
                            >
                                <span
                                    style={{
                                        display: 'inline-block',
                                        width: 28,
                                        height: 20,
                                        backgroundColor: opt.color,
                                        borderRadius: 3,
                                    }}
                                />                                
                                <span>{t(`setting.displayColors.${opt.value}`)}</span>
                                {selected?.color === opt.color && (
                                    <span style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}>
                                        <IconCheckBlue width={18} height={18} />
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="pl-5 flex gap-10">
            <div>
                <p className="mb-[16px] text-[18px] font-normal leading-[110%]">{t('setting.wave')}</p>
                <div
                    className="flex flex-col flex-wrap max-h-[345px] w-[688px]"
                    style={{
                        rowGap: 20,
                        columnGap: 16
                    }}
                >
                    {parameterColors.waveParameterColors.map((param, idx) => (
                        <div
                            key={param.measureParameter}
                            style={{
                                minWidth: 160,
                                maxHeight: 53,
                                marginBottom: idx === parameterColors.waveParameterColors.length - 1 ? 0 : undefined
                            }}
                        >
                            <div className="mb-[6px] text-[14px] leading-[110%] opacity-70 font-light">{param.measureParameter}</div>
                            {renderDropdown(param.measureParameter, selectParameterColors['waveParameterColors'][param.measureParameter], handleSelectColors,'wave',idx)}
                        </div>
                    ))}
                </div>
            </div>
            <div className="bg-[#383838] h-[408px] w-[1px]"></div>
            <div>
                <p className="mb-[16px] text-[18px] font-normal leading-[110%]">{t('setting.numeric')}</p>
                <div
                    className="flex flex-col flex-wrap max-h-[345px] w-[688px]"
                    style={{
                        rowGap: 20,
                        columnGap: 16
                    }}
                >
                    {parameterColors.numericParameterColors.map((param, idx) => (
                        <div
                            key={param.measureParameter}
                            style={{
                                minWidth: 160,
                                maxHeight: 53,
                                marginBottom: idx === parameterColors.numericParameterColors.length - 1 ? 0 : undefined
                            }}
                        >
                            <div className="mb-[6px] text-[14px] leading-[110%] opacity-70 font-light">{param.measureParameter}</div>
                            {renderDropdown(param.measureParameter, selectParameterColors['numericParameterColors'][param.measureParameter], handleSelectColors,'numeric',idx)}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SetParameterColor

